// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-vesting-outer-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-bottom: 50px;
}

.add-vesting-inner-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 25px;
    width: 80%;
    box-shadow: -6px 10px 40px 0px #00000014;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.5) -1.68%, rgba(255, 255, 255, 0.1) 100%);
    border: 1px solid #ffffff;
    border-radius: 10px;
    padding: 28px 0px;
    margin-top: 20px;
}

.av-head-cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #bbb8b8;
    padding: 0px 28px 28px 28px;
}

.avhc-tresaury-cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.av-heading {
    color: #000000;
    font-size: 24px;
    font-weight: 600;
    margin: 0px;
}

.add-vesting-input-content-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 25px;
    width: 100%;
    padding: 0px 28px;
}

.add-vesting-input-content-cont div {
    width: 100%;
}

.add-vesting-input-content-cont p {
    margin-bottom: 10px;
}

.add-vesting-input-content-cont p,
.add-vesting-input-content-cont label {
    color: #000000;
    font-size: 16px;
    font-weight: 500;
}

.add-vesting-input {
    outline: none;
    border: 1px solid #515151;
    border-radius: 6px;
    color: #515151;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 10px;
    width: 100%;
}

.add-vesting-radio {
    height: 20px;
    width: 20px;
}

.av-radio-u-cont {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 35px;
}

.av-radio-cont {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    width: fit-content !important;
}

.av-btn-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 25px;
}

.add-vesting-btn {
    box-shadow: 0px 4px 4px 0px #00000040;
    border-radius: 38px;
    padding: 8px 40px;
    outline: none;
    border: 3px solid transparent;
    background: linear-gradient(90deg, #234B9A, #234B9A, #234B9A) padding-box, linear-gradient(180deg, #234B9A 0%, #FFFFFF 100%) border-box;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    width: 55%;
}

.add-vesting-btn:hover {
    color: #234B9A;
    background: #ffffff;
    border: 3px solid #234B9A;
    font-weight: 600;
}

input[type="number"] {
    counter-increment: none;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
}

.input-error {
    color: #ff0000;
    font-size: 16px;
    font-weight: 500;
}

.av-date-input {
    cursor: pointer;
    padding-right: 40px;
}

input[type="datetime-local"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
}

/* Hide native calendar icon for Firefox */
input[type="datetime-local"]::-moz-calendar-picker-indicator {
    display: none;
}

/* Hide native calendar icon for IE and older versions of Edge */
input[type="datetime-local"]::-ms-clear {
    display: none;
}

input[type="radio"] {
    cursor: pointer;
}

/* Vesting View component style */
.vesting-list-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
    height: fit-content;
}

.vlc-box {
    box-shadow: 2px 2px 10px 0px #00000024;
    background: #FFFFFF33;
    border-radius: 10px;
    padding-top: 20px;
    min-width: 315px;
    width: 32%;
    cursor: pointer;

}

.vlc-box-heading {
    color: #000000;
    font-size: 20px;
    font-weight: 700;
    padding: 0px 20px;
    margin-bottom: 12px;
}

.vlc-box-total-cont {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 7px;
    padding: 0 20px;
    margin-bottom: 10px;
}

.vlc-box-total-cont>p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0px;
}

.vlc-box-total-cont>p>span:first-child {
    color: #515151;
    font-size: 16px;
    font-weight: 500;
}

.vlc-box-total-cont>p>span:nth-child(2) {
    color: #000000;
    font-size: 16px;
    font-weight: 600;
}

.vlc-box-vested-dura-cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: #234B9A1A;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 10px;
}

.vlc-box-vested-dura-cont>span:first-child {
    color: #515151;
    font-size: 16px;
    font-weight: 500;
}

.vlc-box-vested-dura-cont>span:nth-child(2) {
    color: #000000;
    font-size: 14px;
    font-weight: 600;
}

/* Vesting details component style */
.vest-details-header-cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 15px;
}

.vd-heading {
    font-size: 24px;
    font-weight: 600;
    color: #000000;
}

.relase-token-btn {
    box-shadow: 0px 4px 4px 0px #00000040;
    border-radius: 38px;
    padding: 7px 20px;
    outline: none;
    border: 3px solid transparent;
    background: linear-gradient(90deg, #234B9A, #234B9A, #234B9A) padding-box, linear-gradient(180deg, #234B9A 0%, #FFFFFF 100%) border-box;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
}

.relase-token-btn:hover {
    color: #234B9A;
    background: #ffffff;
    border: 3px solid #234B9A;
    font-weight: 600;
}

.vd-cont {
    box-shadow: 2px 2px 16px 0px #00000014;
    background: #FFFFFF4D;
    border-radius: 14px;
    padding: 24px;
    margin-bottom: 25px;
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.vdc-box-cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.vd-box1 {
    background: #F4F8FC;
    padding: 12px 16px;
    border-radius: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 48%;
}

.vd-box1>p {
    margin: 0px;
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #515151;
}

.vd-box1>p>span {
    color: #000000;
}

.vb-box2-outer {
    width: 32%;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.vb-box2-outer>p {
    margin-bottom: 0px;
    font-size: 15px;
    font-weight: 500;
    color: #000000;
}

.vb-box2 {
    background: #F4F8FC;
    padding: 12px 16px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    color: #4094F7;
    font-size: 20px;
    font-weight: 600;
}

.vb-box2>p {
    margin: 0px;
}

.vdc-bar-heading {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    padding-left: 30px;
}

.vd-chart-cont {
    height: 350px;
}

/* toggle style */
.switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 26px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #7B7B7C;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 19px;
    width: 19px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: .4s;
}

input:checked+.slider {
    background: #234B9A;
}

input:focus+.slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked+.slider:before {
    transform: translateX(20px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Vesting/Vesting.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,wCAAwC;IACxC,kGAAkG;IAClG,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,6BAA6B;IAC7B,uIAAuI;IACvI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAII,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA,0CAA0C;AAC1C;IACI,aAAa;AACjB;;AAEA,gEAAgE;AAChE;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,eAAe;;AAEnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,QAAQ;IACR,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,+BAA+B;IAC/B,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,6BAA6B;IAC7B,uIAAuI;IACvI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IAEzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IAEvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IAGI,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".add-vesting-outer-cont {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding-bottom: 50px;\n}\n\n.add-vesting-inner-cont {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 25px;\n    width: 80%;\n    box-shadow: -6px 10px 40px 0px #00000014;\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0.5) -1.68%, rgba(255, 255, 255, 0.1) 100%);\n    border: 1px solid #ffffff;\n    border-radius: 10px;\n    padding: 28px 0px;\n    margin-top: 20px;\n}\n\n.av-head-cont {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    border-bottom: 1px solid #bbb8b8;\n    padding: 0px 28px 28px 28px;\n}\n\n.avhc-tresaury-cont {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n}\n\n.av-heading {\n    color: #000000;\n    font-size: 24px;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.add-vesting-input-content-cont {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 25px;\n    width: 100%;\n    padding: 0px 28px;\n}\n\n.add-vesting-input-content-cont div {\n    width: 100%;\n}\n\n.add-vesting-input-content-cont p {\n    margin-bottom: 10px;\n}\n\n.add-vesting-input-content-cont p,\n.add-vesting-input-content-cont label {\n    color: #000000;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.add-vesting-input {\n    outline: none;\n    border: 1px solid #515151;\n    border-radius: 6px;\n    color: #515151;\n    font-size: 16px;\n    font-weight: 500;\n    padding: 8px 10px;\n    width: 100%;\n}\n\n.add-vesting-radio {\n    height: 20px;\n    width: 20px;\n}\n\n.av-radio-u-cont {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 35px;\n}\n\n.av-radio-cont {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 10px;\n    width: fit-content !important;\n}\n\n.av-btn-cont {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    margin-top: 25px;\n}\n\n.add-vesting-btn {\n    box-shadow: 0px 4px 4px 0px #00000040;\n    border-radius: 38px;\n    padding: 8px 40px;\n    outline: none;\n    border: 3px solid transparent;\n    background: linear-gradient(90deg, #234B9A, #234B9A, #234B9A) padding-box, linear-gradient(180deg, #234B9A 0%, #FFFFFF 100%) border-box;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 600;\n    width: 55%;\n}\n\n.add-vesting-btn:hover {\n    color: #234B9A;\n    background: #ffffff;\n    border: 3px solid #234B9A;\n    font-weight: 600;\n}\n\ninput[type=\"number\"] {\n    counter-increment: none;\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    margin: 0;\n}\n\n.input-error {\n    color: #ff0000;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.av-date-input {\n    cursor: pointer;\n    padding-right: 40px;\n}\n\ninput[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n    display: none;\n    -webkit-appearance: none;\n}\n\n/* Hide native calendar icon for Firefox */\ninput[type=\"datetime-local\"]::-moz-calendar-picker-indicator {\n    display: none;\n}\n\n/* Hide native calendar icon for IE and older versions of Edge */\ninput[type=\"datetime-local\"]::-ms-clear {\n    display: none;\n}\n\ninput[type=\"radio\"] {\n    cursor: pointer;\n}\n\n/* Vesting View component style */\n.vesting-list-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    width: 100%;\n    height: fit-content;\n}\n\n.vlc-box {\n    box-shadow: 2px 2px 10px 0px #00000024;\n    background: #FFFFFF33;\n    border-radius: 10px;\n    padding-top: 20px;\n    min-width: 315px;\n    width: 32%;\n    cursor: pointer;\n\n}\n\n.vlc-box-heading {\n    color: #000000;\n    font-size: 20px;\n    font-weight: 700;\n    padding: 0px 20px;\n    margin-bottom: 12px;\n}\n\n.vlc-box-total-cont {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 7px;\n    padding: 0 20px;\n    margin-bottom: 10px;\n}\n\n.vlc-box-total-cont>p {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin: 0px;\n}\n\n.vlc-box-total-cont>p>span:first-child {\n    color: #515151;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.vlc-box-total-cont>p>span:nth-child(2) {\n    color: #000000;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.vlc-box-vested-dura-cont {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    background: #234B9A1A;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    padding: 10px;\n}\n\n.vlc-box-vested-dura-cont>span:first-child {\n    color: #515151;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.vlc-box-vested-dura-cont>span:nth-child(2) {\n    color: #000000;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n/* Vesting details component style */\n.vest-details-header-cont {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 15px;\n}\n\n.vd-heading {\n    font-size: 24px;\n    font-weight: 600;\n    color: #000000;\n}\n\n.relase-token-btn {\n    box-shadow: 0px 4px 4px 0px #00000040;\n    border-radius: 38px;\n    padding: 7px 20px;\n    outline: none;\n    border: 3px solid transparent;\n    background: linear-gradient(90deg, #234B9A, #234B9A, #234B9A) padding-box, linear-gradient(180deg, #234B9A 0%, #FFFFFF 100%) border-box;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.relase-token-btn:hover {\n    color: #234B9A;\n    background: #ffffff;\n    border: 3px solid #234B9A;\n    font-weight: 600;\n}\n\n.vd-cont {\n    box-shadow: 2px 2px 16px 0px #00000014;\n    background: #FFFFFF4D;\n    border-radius: 14px;\n    padding: 24px;\n    margin-bottom: 25px;\n    width: 100%;\n    height: fit-content;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.vdc-box-cont {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.vd-box1 {\n    background: #F4F8FC;\n    padding: 12px 16px;\n    border-radius: 8px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 48%;\n}\n\n.vd-box1>p {\n    margin: 0px;\n    margin-left: 10px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #515151;\n}\n\n.vd-box1>p>span {\n    color: #000000;\n}\n\n.vb-box2-outer {\n    width: 32%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.vb-box2-outer>p {\n    margin-bottom: 0px;\n    font-size: 15px;\n    font-weight: 500;\n    color: #000000;\n}\n\n.vb-box2 {\n    background: #F4F8FC;\n    padding: 12px 16px;\n    border-radius: 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    color: #4094F7;\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.vb-box2>p {\n    margin: 0px;\n}\n\n.vdc-bar-heading {\n    color: #000000;\n    font-size: 20px;\n    font-weight: 600;\n    padding-left: 30px;\n}\n\n.vd-chart-cont {\n    height: 350px;\n}\n\n/* toggle style */\n.switch {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 26px;\n}\n\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #7B7B7C;\n    -webkit-transition: .4s;\n    transition: .4s;\n}\n\n.slider:before {\n    position: absolute;\n    content: \"\";\n    height: 19px;\n    width: 19px;\n    left: 4px;\n    bottom: 4px;\n    background-color: white;\n    -webkit-transition: .4s;\n    transition: .4s;\n}\n\ninput:checked+.slider {\n    background: #234B9A;\n}\n\ninput:focus+.slider {\n    box-shadow: 0 0 1px #2196F3;\n}\n\ninput:checked+.slider:before {\n    -webkit-transform: translateX(24px);\n    -ms-transform: translateX(24px);\n    transform: translateX(20px);\n}\n\n/* Rounded sliders */\n.slider.round {\n    border-radius: 34px;\n}\n\n.slider.round:before {\n    border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
